export default __webpack_public_path__ + "static/1_34-be21407b45b2df25170bb1067d267178.png";